/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Representation of assessment including status, runtime, progress and Risk Indicator when
 * assessment is complete
 * @export
 * @interface NotificationProgress
 */
export interface NotificationProgress {
  /**
   *
   * @type {number}
   * @memberof NotificationProgress
   */
  readonly id: number;
  /**
   * The current status of the assessment.
   * @type {string}
   * @memberof NotificationProgress
   */
  readonly status: string;
  /**
   * The current progress of the assessment.
   * @type {number}
   * @memberof NotificationProgress
   */
  readonly progress: number;
}

/**
 * Check if a given object implements the NotificationProgress interface.
 */
export function instanceOfNotificationProgress(value: object): value is NotificationProgress {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('status' in value) || value['status'] === undefined) return false;
  if (!('progress' in value) || value['progress'] === undefined) return false;
  return true;
}

export function NotificationProgressFromJSON(json: any): NotificationProgress {
  return NotificationProgressFromJSONTyped(json, false);
}

export function NotificationProgressFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationProgress {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    status: json['status'],
    progress: json['progress'],
  };
}

export function NotificationProgressToJSON(
  value?: Omit<NotificationProgress, 'id' | 'status' | 'progress'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {};
}
